import { AxiosResponse } from "axios";
import { useEffect } from "react";
import { useContext, useRef, useState } from "react";
import { useHistory } from 'react-router-dom';
import { AdminFrame } from "views/common/AdminFrame";
import { CtxAuth } from "views/utils/Contexts";
import { getApiDataWithToken, postApiDataWithToken, delApiDataWithToken, putApiDataWithToken} from "views/utils/CallApi";
import { getRef, setRef, getRefTextArea, setRefTextArea } from "views/utils/InputHelp";
import * as Validation from "../../../utils/Validation";
import * as mb from "views/common/MessageBox";
import { Dialog } from "views/common/Dialog";
import { scrollTop } from "views/utils/CommonFunc";
import { InputDate } from "views/common/InputDate";

interface IFServiceHistory {
    serviceId: string,
    serviceName: string,
    serviceSortNo: number
}

interface IFServiceOption {
    service_id: string,
    option_id: string
}

export function OptionEdit(): JSX.Element{

    const cua = useContext(CtxAuth);
    const [msgArgs, setMsgArgs] = useState({type:"", text:""});
    const [serviceHistory, setServiceHistory] = useState<IFServiceHistory[]>([]);
    const [selectServiceHistory, setSelectServiceHistory] = useState<IFServiceHistory[]>([]);
    const [selectServices, setSelectServices] = useState<IFServiceHistory[]>([]);
    const [deleteServices, setDeleteServices] = useState<IFServiceHistory[]>([]);
    const [submitDisabled, setSubmitDisabled] = useState<boolean>(false);
    const [imageEncode, setImageEncode] = useState("");
    const [accessUrl, setaccessUrl] = useState("");
    const [imageSize, setImageSize] = useState(0);
    const [saveCallFlag, setSaveCallFlag] = useState(0);
    const history = useHistory();
    const optionId = useRef<HTMLInputElement>(null);
    const optionName = useRef<HTMLInputElement>(null);
    const optionSortNo = useRef<HTMLInputElement>(null);
    const optionPrice = useRef<HTMLInputElement>(null);
    const optionImage = useRef<HTMLInputElement>(null);
    const optionStart = useRef<HTMLInputElement>(null);
    const optionExplanation = useRef<HTMLTextAreaElement>(null);
    const url = new URL(window.location.href);
    const params = url.searchParams;
    const [isShow, setIsShow] = useState<boolean>(false);

    useEffect(function(){       
        // 編集の場合、情報の取得と表示
        if(params.get('optionId') != null){
            getApiDataWithToken(`/management/options/option/${params.get('optionId')}`,
                {},
                cua.getToken(),
                function(res:AxiosResponse<any>){

                    switch (res.status){
                        case 200:

                            setRef(optionId,res.data.option_id);
                            setRef(optionName,res.data.option_name);
                            setRef(optionSortNo,res.data.option_sort_no);
                            setRef(optionPrice,res.data.option_price);
                            setRef(optionStart,res.data.option_start.toString());
                            setRefTextArea(optionExplanation,res.data.option_explanation);
                            
                            //サービス一覧と対象サービス取得
                            let seHistory:IFServiceHistory[] = [];
                            for (let index = 0; index < res.data.service_results.length; index++) {
                                seHistory.push({serviceId:res.data.service_results[index].service_id, serviceName:res.data.service_results[index].service_name, serviceSortNo:res.data.service_results[index].service_sort_no});
                            }

                            let ssHistory:IFServiceHistory[] = [];
                            for (let index = 0; index < res.data.service_list.length; index++) {
                                ssHistory.push({serviceId:res.data.service_list[index].service_id, serviceName:res.data.service_list[index].service_name, serviceSortNo:res.data.service_list[index].service_sort_no});
                                const removeService = seHistory.filter(item => item.serviceId !== res.data.service_list[index].service_id);
                                seHistory = removeService;
                            }
                            setSelectServiceHistory(ssHistory);
                            setServiceHistory(seHistory);

                            //画像の表示
                            if(res.data.option_image !== null && res.data.option_image !== undefined){
                                const imgs:string = res.data.option_image.toString();
                                let imgTag = document.getElementById("preview") as HTMLImageElement;
                                imgTag.src = imgs;
                                setaccessUrl(imgs);
                                //画像が設定された場合、labelタグにis-settedクラスを追加
                                let label = document.getElementById("image-label") as HTMLLabelElement
                                label.classList.add("is-selected")
                            }
                            break;
                        default:
                            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"画面のロードに失敗しました。"});
                    }
                }
            );
        }else{

            //新規登録の場合サービス情報を取得する
            let seHistory:IFServiceHistory[] = [];
            getApiDataWithToken('/management/services',
            {},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:
                        for (let index = 0; index < res.data.service_list.length; index++) {
                            seHistory.push({serviceId:res.data.service_list[index].service_id, serviceName:res.data.service_list[index].service_name, serviceSortNo:res.data.service_list[index].service_sort_no});
                        }

                        setServiceHistory(seHistory);
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"画面のロードに失敗しました。"});
                }
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    //-------------------------------------
    //保存
    //-------------------------------------
    function clickSave(){ 
        //ボタンを押したタイミングで非活性にする
        setSubmitDisabled(true); 
        //トップに移動
        scrollTop();

        //バリデーションチェック
        if(!validCheck()){
            //ボタンを活性にする
            setSubmitDisabled(false); 
            return false;
        }

        //画像アップロードとURLを取得
        if(params.get('optionId') !== null && imageEncode === ""){
            //編集時かつ画像のエンコードデータが無い場合、画像を再アップロードしない
            setSaveCallFlag(1);

        }else if(imageEncode === ""){
            //画像を設定していない場合
            setaccessUrl("")
            setSaveCallFlag(1);
            
        }else{
            postApiDataWithToken('/management/image/upload',
            {"image": imageEncode, "genre": "option"},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:             
                        setaccessUrl(res.data.access_url);
                        setSaveCallFlag(1);
                                
                       break;
                    default:
                    setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"画像登録に失敗しました。"});
                }
            });  
        }
    }

    //-------------------------------------
    //保存　画像URL取得後
    //-------------------------------------
    useEffect(function(){
        if(saveCallFlag !== 0){

            //対象サービスに追加されているサービスのIDリストを作成
            const serviceIds:IFServiceOption[]= [];
            for (let index = 0; index <selectServiceHistory.length; index++) {
                serviceIds.push({service_id:selectServiceHistory[index].serviceId, option_id:getRef(optionId)});
            }
            // optionIdがある場合、更新
            if(params.get('optionId') !== null){

                putApiDataWithToken('/management/options/option/change',
                {'new_option_id': getRef(optionId),
                    'old_option_id': params.get('optionId'),
                    'option_name': getRef(optionName),
                    'option_price': getRef(optionPrice),
                    'option_image': accessUrl, 
                    'option_explanation':  getRefTextArea(optionExplanation),
                    'option_start': getRef(optionStart),
                    'open_flg': "1",
                    'delete_flg': "0",
                    'option_sort_no': getRef(optionSortNo),
                    'service_list': serviceIds},
                cua.getToken(),
                function(res:AxiosResponse<any>){
                    switch (res.status){
                        case 200:
                            setMsgArgs({type:mb.MSGBOX_TYPE_SUCCESS, text:"オプションを更新しました。"});
                            setSubmitDisabled(true);
                            //「ファイルを選択」を表示しないためのクラス名追加
                            let label = document.getElementById("image-label") as HTMLLabelElement
                            label.classList.add("is-disabled")
                            break;
                        case 400:
                            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"オプションIDが既に存在しています。"});
                            setSaveCallFlag(0);
                            setSubmitDisabled(false);
                            break;
                        default:
                            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"オプションの更新に失敗しました。"});
                            setSubmitDisabled(false);
                    }
                });
            }else{
                // optionIdが無い場合、新規登録
                postApiDataWithToken('/management/options/option/register',
                {'option_id': getRef(optionId),
                    'option_name': getRef(optionName),
                    'option_price': getRef(optionPrice),
                    'option_image':accessUrl, 
                    'option_explanation':  getRefTextArea(optionExplanation),
                    'option_start': getRef(optionStart),
                    'open_flg': "1",
                    'delete_flg': "0",
                    'option_sort_no': getRef(optionSortNo),
                    'service_list': serviceIds},
                cua.getToken(),
                function(res:AxiosResponse<any>){
                    switch (res.status){
                        case 200:
                            setMsgArgs({type:mb.MSGBOX_TYPE_SUCCESS, text:"オプションを登録しました。"});
                            setSubmitDisabled(true);
                            //「ファイルを選択」を表示しないためのクラス名追加
                            let label = document.getElementById("image-label") as HTMLLabelElement
                            label.classList.add("is-disabled")
                            break;
                        case 400:
                            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"オプションIDが既に存在しています。"});
                            setSaveCallFlag(0);
                            setSubmitDisabled(false);
                            break;
                        default:
                            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"オプションの登録に失敗しました。"});
                            setSubmitDisabled(false);
                    }
                });
            }
            //ボタンを活性にする
            setSaveCallFlag(0);
            setSubmitDisabled(false);
        }
    }, [saveCallFlag]);
    
    //-------------------------------------
    //削除
    //-------------------------------------
    function clickDelete(){

        //ボタンを押したタイミングで非活性にする
        setSubmitDisabled(true);
        let apiUrl = `/management/options/option/delete/${getRef(optionId)}`
        delApiDataWithToken(apiUrl,
        {},
        cua.getToken(),
        function(res:AxiosResponse<any>){
            switch (res.status){
                case 200:
                    setMsgArgs({type:mb.MSGBOX_TYPE_SUCCESS, text:"オプション情報の削除が完了しました。"});
                    history.push('/admin/option/list');
                    break;
                default:
                    setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"オプション情報の削除に失敗しました。"});
            }
            //ボタンを活性にする
            setSubmitDisabled(false);
        }
    );

    }

    //-------------------------------------
    //サービス追加
    //-------------------------------------
    function clickRowAdd(){
        let selServices:IFServiceHistory[] = selectServices;
        let ssHistory:IFServiceHistory[] = selectServiceHistory;
        let seHistory:IFServiceHistory[] = serviceHistory;

        //サービス一覧で選択されている情報を対象サービスに追加
        for (let index = 0; index < selectServices.length; index++) {
            ssHistory.push({serviceId:selectServices[index].serviceId, serviceName:selectServices[index].serviceName, serviceSortNo:selectServices[index].serviceSortNo});
            //選択されている情報をサービス一覧から削除
            const removeService = seHistory.filter(item => item.serviceId !== selectServices[index].serviceId);
            seHistory = removeService;
        }

        //表示順でソート
        ssHistory.sort((a, b) => {
            if (a.serviceSortNo < b.serviceSortNo) return -1;
            if (a.serviceSortNo > b.serviceSortNo) return 1;
            return 0;
        });
        seHistory.sort((a, b) => {
            if (a.serviceSortNo < b.serviceSortNo) return -1;
            if (a.serviceSortNo > b.serviceSortNo) return 1;
            return 0;
        });
        setSelectServiceHistory(ssHistory);
        setServiceHistory(seHistory);

        //保持しているサービス情報を初期化
        selServices = [];
        setSelectServices(selServices);
        //サービスの選択状態を解除
        const list = document.getElementById('selectService') as HTMLSelectElement;
        list.selectedIndex = -1;
    }

    //-------------------------------------
    //サービス削除
    //-------------------------------------
    function clickRowDel(){
        let delServices:IFServiceHistory[] = deleteServices;
        let ssHistory:IFServiceHistory[] = selectServiceHistory;
        let seHistory:IFServiceHistory[] = serviceHistory;

        //選択されているサービス情報をサービス一覧に戻す
        for (let index = 0; index < delServices.length; index++) {
            seHistory.push({serviceId:delServices[index].serviceId, serviceName:delServices[index].serviceName, serviceSortNo:delServices[index].serviceSortNo});
            //選択された情報を対象サービスから削除
            const removeService = ssHistory.filter(item => item.serviceId !== delServices[index].serviceId);
            ssHistory = removeService;
        }

        //表示順でソート
        ssHistory.sort((a, b) => {
            if (a.serviceSortNo < b.serviceSortNo) return -1;
            if (a.serviceSortNo > b.serviceSortNo) return 1;
            return 0;
         });
        seHistory.sort((a, b) => {
            if (a.serviceSortNo < b.serviceSortNo) return -1;
            if (a.serviceSortNo > b.serviceSortNo) return 1;
            return 0;
        });
        setSelectServiceHistory(ssHistory);
        setServiceHistory(seHistory);

        //保持しているselectServicesを初期化
        delServices = [];
        setDeleteServices(delServices);
        //サービスの選択状態を解除
        const list = document.getElementById('deleteService') as HTMLSelectElement;
        list.selectedIndex = -1;
    }

    //-------------------------------------
    //選択サービス保持
    //-------------------------------------
    const rowAddService = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedOptions = event.currentTarget.selectedOptions;
        const selectService:IFServiceHistory[] = [];

        //選択されたサービス情報をselectServiceに保持
        for (let i = 0; i < selectedOptions.length; i++) {
            selectService.push({serviceId:selectedOptions[i].value, serviceName:selectedOptions[i].innerText, serviceSortNo:Number(selectedOptions[i].id)});
        }
        setSelectServices(selectService);

    };

    const rowDelService = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const selectedOptions = event.currentTarget.selectedOptions;
        const deletetService:IFServiceHistory[] = [];

        //選択されたサービス情報をselectServiceに保持
        for (let i = 0; i < selectedOptions.length; i++) {
            deletetService.push({serviceId:selectedOptions[i].value, serviceName:selectedOptions[i].innerText, serviceSortNo:Number(selectedOptions[i].id)});
        }
        setDeleteServices(deletetService);
    };

    //-------------------------------------
    //画像表示　保持
    //-------------------------------------
    const registerImg = (event: React.ChangeEvent<HTMLInputElement>) => {

        if (event.target.files === null) {
            return;
        }
        const file = event.target.files[0];
        if (file === null) {
            return;
        }

        let imgTag = document.getElementById("preview") as HTMLImageElement;
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const result: string = reader.result as string;
            imgTag.src = result;
            const img = result.slice(result.indexOf(",") + 1);
            setImageEncode(img);
            setImageSize(file.size);
            //画像が設定された場合、labelタグにis-settedクラスを追加
            let label = document.getElementById("image-label") as HTMLLabelElement
            label.classList.add("is-selected")
        }
    };

    //-------------------------------------
    //削除確認画面
    //-------------------------------------
    function clickOpen(){
        setIsShow(true);
    }

    //-------------------------------------
    //画像削除
    //-------------------------------------
    function delImage(){

        let imgTag = document.getElementById("preview") as HTMLImageElement;
        imgTag.src = "";
        setImageSize(0)
        setImageEncode("")
        setaccessUrl("")
        //画像が削除された場合、labelタグからis-settedクラスを削除
        let label = document.getElementById("image-label") as HTMLLabelElement
        label.classList.remove("is-selected")
    }

    //-------------------------------------
    //バリデーション
    //-------------------------------------
    function validCheck(){
        let errmsg:string;

        //ID入力チェック
        errmsg = Validation.checkEmptyTextBox(getRef(optionId), "オプションID")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }
        errmsg = Validation.checkLengthOver(getRef(optionId), 20, "オプションID")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }
        errmsg = Validation.checkHankakuEisuRule(getRef(optionId), "オプションID");
        if (errmsg) {
            setMsgArgs({ type: mb.MSGBOX_TYPE_ERROR, text: errmsg });
            return false;
        }

        //オプション名チェック
        errmsg = Validation.checkEmptyTextBox(getRef(optionName), "オプション名")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }
        errmsg = Validation.checkLengthOver(getRef(optionName), 100, "オプション名")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }

        //表示順チェック
        errmsg = Validation.checkRangeNumber(Number(getRef(optionSortNo)), 0, 1000, "表示順")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }
        errmsg = Validation.checkNumberMinus(getRef(optionSortNo), "表示順");
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }

        //単価チェック
        errmsg = Validation.checkEmptyTextBox(getRef(optionPrice), "単価")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }
        errmsg = Validation.checkLengthOver(getRef(optionPrice), 8, "単価")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }
        errmsg = Validation.checkPositiveInteger(Number(getRef(optionPrice)), "単価")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }

        //運用開始日チェック
        errmsg = Validation.checkEmptyTextBox(getRef(optionStart), "運用開始日")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }

        //画像チェック
        errmsg = Validation.checkImageSize(imageSize)
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }

        //説明チェック
        errmsg = Validation.checkLengthOver(getRefTextArea(optionExplanation), 256, "説明")
        if (errmsg){
            setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:errmsg});
            return false;
        }

        return true;
    }

    return (
        <AdminFrame>
            <div className="contents">
            <mb.MessageBox args={msgArgs}/>
                <div className="breadcrumb"><a href="list">← 一覧に戻る</a></div>
                <h2 className="settings-title-h2">オプション管理 &gt; 詳細</h2>
                <div className="settings-wrap-short">
                <div className="settings-block">
                    <h3 className="settings-title-h3">オプション情報</h3>
                    <div className="settings-form">
                    <div className="form-row">
                        <div className="form-row-title">ID</div>
                        <div className="form-row-input"><input type="text" ref={optionId} disabled={submitDisabled}/></div>
                    </div>
                    <div className="form-row">
                        <div className="form-row-title">名前</div>
                        <div className="form-row-input"><input type="text" ref={optionName} disabled={submitDisabled}/></div>
                    </div>
                    <div className="form-row">
                        <div className="form-row-title">表示順</div>
                        <div className="form-row-input"><input type="text" ref={optionSortNo} disabled={submitDisabled}/></div>
                    </div>
                    <div className="form-row">
                        <div className="form-row-title">単価</div>
                        <div className="form-row-input"><input type="text" ref={optionPrice} disabled={submitDisabled}/></div>
                    </div>
                    <div className="form-row">
                        <div className="form-row-title">運用開始日</div>
                        <InputDate refElm={optionStart} disabled={submitDisabled}/>
                    </div>
                    <div className="form-row">
                        <div className="form-row-title">画像</div>
                        <div className="form-row-comment">設定できる画像のサイズは1MBまでです。</div>
                        <div className="form-row-input">
                        <label className="file" id="image-label"><input id = "file" onChange={(e) => {registerImg(e)}} type="file" accept=".jpg, .jpeg, .png, .gif" ref={optionImage} disabled={submitDisabled}/><img src="" alt="" id = "preview"className="preview"/></label>
                        <button className="btn-tertiary btn-icon-left margin-t-10" onClick={delImage} disabled={submitDisabled}>
                            <span className="icon material-icons-round md-18">clear</span>画像を削除
                        </button>
                        </div>
                    </div>
                    <div className="form-row">
                        <div className="form-row-title">説明</div>
                        <div className="form-row-input"><textarea  ref={optionExplanation} rows={5} disabled={submitDisabled}></textarea></div>
                    </div>
                    <div className="form-row">
                        <div className="form-row-title">対象サービス</div>
                        <div className="form-multiselect">
                        <div className="form-multiselect-selected">
                            <select id ="deleteService" onChange={rowDelService} size={10} multiple disabled={submitDisabled}>
                            {selectServiceHistory?.map(function(val, idx){
                                return(
                                    <option key = {idx} id = {String(val.serviceSortNo)} value ={val.serviceId}>{val.serviceName}</option>
                                )
                            })}
                            </select>
                        </div>
                        <div className="form-multiselect-button">
                            <div><button className="btn-tertiary btn-icon-left" onClick={clickRowAdd} disabled={submitDisabled}><span className="icon material-icons-round">arrow_back</span><span className="btn-tertiary-text">追加</span></button></div>
                            <div><button className="btn-tertiary btn-icon-right" onClick={clickRowDel} disabled={submitDisabled}><span className="btn-tertiary-text">削除</span><span className="icon material-icons-round">arrow_forward</span></button></div>
                        </div>
                        <div className="form-multiselect-list">
                            <select id ="selectService" onChange={rowAddService} size={10} multiple disabled={submitDisabled}>
                            {serviceHistory?.map(function(val, idx){
                                return(
                                    <option key = {idx} id = {String(val.serviceSortNo)} value ={val.serviceId}>{val.serviceName}</option>
                                )
                            })}
                            </select>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>
                <div className="control-horizon control-between margin-tb-20">
                    <button className="btn-primary" onClick={clickSave} disabled={submitDisabled}>変更を保存</button>
                    {params.get('optionId') && <button className="btn-tertiary" onClick={clickOpen} disabled={submitDisabled}>削除</button>}
                    <Dialog isShow = {isShow} setIsShow = {setIsShow} callback={clickDelete} msg = {"オプションを削除してもよろしいですか？"}/>
                </div>
                </div>
            </div>
        </AdminFrame>
    )
}